'use client'

import { lazy, Suspense } from 'react'

type LazyMarkdownMessageProps = {
  content: string
}

const MarkdownMessageImpl = lazy(() =>
  import('@/components/ai-chat/markdown-message').then((mod) => ({
    default: mod.MarkdownMessage,
  })),
)

function MarkdownMessageFallback({ content }: LazyMarkdownMessageProps) {
  return <div className="whitespace-pre-wrap break-words">{content}</div>
}

export function LazyMarkdownMessage({ content }: LazyMarkdownMessageProps) {
  return (
    <Suspense fallback={<MarkdownMessageFallback content={content} />}>
      <MarkdownMessageImpl content={content} />
    </Suspense>
  )
}
